/*=========================================================================================
  File Name: moduleUserGetters.js
  Description: User Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {
  getAdmin: state =>(login_id) => state.admins.find(admin => admin.login_id === login_id)
}
